import React from "react";
const Service = () => {
  return (
    <>
    <div className="contact-banner">
    	<div className="banner-text">
      	<h1>Service</h1>
    	</div>
  	</div>
  	<div className="all-services">
		<div id="cd-timeline" className="cd-container">
		<div className="cd-timeline-block">
			<div className="cd-timeline-img cd-picture">
			</div>
			<div className="cd-timeline-content">
				<h2>Manage Guest</h2>
        		<p>We are taking care of our Guest in their stay.</p>
			</div>
		</div> 
		<div className="cd-timeline-block">
			<div className="cd-timeline-img cd-movie">
			</div> 
			<div className="cd-timeline-content">
				<h2>Guest Satisfaction</h2>
				<p>We take great pride in our operations and strive to provide our guests with the best possible experience during their stay.</p>
			</div> 
		</div>
		<div className="cd-timeline-block">
			<div className="cd-timeline-img cd-picture">
			</div> 
			<div className="cd-timeline-content">
				<h2>Hotel Operation</h2>
				<p>We take great pride in our operations and strive to provide our guests with the best possible experience during their stay.</p>
			</div> 
		</div> 
		<div className="cd-timeline-block">
			<div className="cd-timeline-img cd-location">
			</div>
			<div className="cd-timeline-content">
				<h2>Enhance Profit</h2>
				<p>Enhancing profit requires a combination of strategic thinking, creativity, and implementation of effective tactics.we are here to help you.</p>
			</div> 
		</div> 
		<div className="cd-timeline-block">
			<div className="cd-timeline-img cd-location">
			</div> 
			<div className="cd-timeline-content">
				<h2>Digital Marketing</h2>
				<p>Digital marketing is the practice of promoting products or services through digital channels, such as search engines, social media, email, and websites.</p>
			</div> 
      	</div>
		<div className="cd-timeline-block">
			<div className="cd-timeline-img cd-movie">
			</div>
			<div className="cd-timeline-content">
				<h2>Revenue Management</h2>
				<p>Revenue management is the process of maximizing revenue by optimizing pricing, inventory, and demand.</p>
			</div>
		</div>
		</div>
  	</div>
  </>
  );
};
export default Service;